import { createSlice } from '@reduxjs/toolkit';
import { Marketplace } from 'models/Marketplace';

interface CommonState {
  ga4Initialized: boolean;
  marketplaces: Marketplace[];
}

const initialState: CommonState = {
  ga4Initialized: false,
  marketplaces: [],
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    initializeGa4: (state) => {
      state.ga4Initialized = true;
    },
    setMarketplaces: (state, action: { payload: Marketplace[] }) => {
      state.marketplaces = action.payload;
    },
  },
});

export const { initializeGa4, setMarketplaces } = commonSlice.actions;

export default commonSlice.reducer;
